import React from 'react';

const AuthLayoutBackground = ({ width = 1974 }: { width?: number }) => {
  const aspectRatio = 1974 / 1603;
  const height = width / aspectRatio;

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <use xlinkHref="#radar" mask="url(#bgovrlylgn-hide-sigma)" />
      <use
        xlinkHref="#radar"
        filter="url(#bgovrlylgn-bg-blur)"
        style={{ clipPath: 'url(#bgovrlylgn-sigma-clip)' }}
      />
      <use xlinkHref="#sigma" />
      <path
        d="M1472.98 446.48V573.185H1237.61C1265.91 624.278 1299.66 671.264 1319.62 723.444C1407.31 952.939 1277.28 1207.32 1039.12 1277.61C983.396 1294.52 924.789 1299.84 866.921 1293.25C809.053 1286.65 753.152 1268.28 702.669 1239.28C652.185 1210.27 608.19 1171.24 573.399 1124.59C538.609 1077.95 513.76 1024.68 500.387 968.067C487.014 911.458 485.401 852.712 495.647 795.456C505.893 738.2 527.781 683.648 559.96 635.168C592.139 586.688 633.926 545.308 682.741 513.582C731.557 481.856 786.366 460.458 843.785 450.707C863.558 447.231 883.582 445.373 903.657 445.151C1085.49 445.151 1267.24 445.151 1448.91 445.151C1456.05 445.151 1462.7 445.755 1472.98 446.48ZM917.325 574.514C838.86 574.658 763.666 605.923 708.285 661.432C652.904 716.94 621.873 792.145 622.017 870.502C622.162 948.858 653.47 1023.95 709.055 1079.25C764.64 1134.56 839.949 1165.55 918.413 1165.4C957.265 1165.33 995.722 1157.62 1031.59 1142.71C1067.46 1127.79 1100.03 1105.97 1127.45 1078.48C1154.87 1051 1176.61 1018.39 1191.41 982.518C1206.21 946.645 1213.79 908.213 1213.72 869.415C1213.65 830.616 1205.93 792.212 1190.99 756.394C1176.06 720.577 1154.21 688.047 1126.68 660.663C1099.16 633.279 1066.51 611.577 1030.58 596.795C994.662 582.014 956.177 574.442 917.325 574.514V574.514Z"
        fill="url(#paint6_linear_3:40)"
        fillOpacity="0.1"
      />
      <path
        d="M1973.1 445.773V573.179H1523.58C1523.58 533.289 1522.61 494.487 1524.42 455.927C1524.42 448.312 1534.95 439.729 1542.44 434.29C1602.91 390.29 1665.56 347.741 1725.9 302.895C1751.11 284.567 1774.12 263.394 1794.47 239.797C1804.4 229.519 1810.4 216.088 1811.44 201.843C1812.48 187.597 1808.49 173.438 1800.16 161.831C1791.53 150.448 1779.26 142.374 1765.39 138.963C1751.51 135.552 1736.89 137.011 1723.97 143.095C1691.44 159.05 1663.5 183.226 1629.03 206.314L1529.99 124.479C1598.8 5.53523 1778.51 -37.3765 1892.19 36.3592C1913.05 50.4214 1930.71 68.7247 1944.01 90.0732C1957.31 111.422 1965.96 135.335 1969.38 160.251C1972.8 185.166 1970.93 210.524 1963.88 234.667C1956.83 258.809 1944.76 281.193 1928.47 300.357C1900.31 330.224 1869.32 357.306 1835.95 381.224C1809.47 402.136 1780.69 420.268 1753.84 445.411L1973.1 445.773Z"
        fill="white"
        fillOpacity="0.1"
      />
      <defs>
        <mask id="bgovrlylgn-hide-sigma">
          <rect id="bounding-box" width="100%" height="100%" fill="white" />
          <path
            d="M1472.98 446.48V573.185H1237.61C1265.91 624.278 1299.66 671.264 1319.62 723.444C1407.31 952.939 1277.28 1207.32 1039.12 1277.61C983.396 1294.52 924.789 1299.84 866.921 1293.25C809.053 1286.65 753.152 1268.28 702.669 1239.28C652.185 1210.27 608.19 1171.24 573.399 1124.59C538.609 1077.95 513.76 1024.68 500.387 968.067C487.014 911.458 485.401 852.712 495.647 795.456C505.893 738.2 527.781 683.648 559.96 635.168C592.139 586.688 633.926 545.308 682.741 513.582C731.557 481.856 786.366 460.458 843.785 450.707C863.558 447.231 883.582 445.373 903.657 445.151C1085.49 445.151 1267.24 445.151 1448.91 445.151C1456.05 445.151 1462.7 445.755 1472.98 446.48ZM917.325 574.514C838.86 574.658 763.666 605.923 708.285 661.432C652.904 716.94 621.873 792.145 622.017 870.502C622.162 948.858 653.47 1023.95 709.055 1079.25C764.64 1134.56 839.949 1165.55 918.413 1165.4C957.265 1165.33 995.722 1157.62 1031.59 1142.71C1067.46 1127.79 1100.03 1105.97 1127.45 1078.48C1154.87 1051 1176.61 1018.39 1191.41 982.518C1206.21 946.645 1213.79 908.213 1213.72 869.415C1213.65 830.616 1205.93 792.212 1190.99 756.394C1176.06 720.577 1154.21 688.047 1126.68 660.663C1099.16 633.279 1066.51 611.577 1030.58 596.795C994.662 582.014 956.177 574.442 917.325 574.514V574.514Z"
            fill="black"
          />
        </mask>
        <clipPath id="bgovrlylgn-sigma-clip">
          <path
            d="M1472.98 446.48V573.185H1237.61C1265.91 624.278 1299.66 671.264 1319.62 723.444C1407.31 952.939 1277.28 1207.32 1039.12 1277.61C983.396 1294.52 924.789 1299.84 866.921 1293.25C809.053 1286.65 753.152 1268.28 702.669 1239.28C652.185 1210.27 608.19 1171.24 573.399 1124.59C538.609 1077.95 513.76 1024.68 500.387 968.067C487.014 911.458 485.401 852.712 495.647 795.456C505.893 738.2 527.781 683.648 559.96 635.168C592.139 586.688 633.926 545.308 682.741 513.582C731.557 481.856 786.366 460.458 843.785 450.707C863.558 447.231 883.582 445.373 903.657 445.151C1085.49 445.151 1267.24 445.151 1448.91 445.151C1456.05 445.151 1462.7 445.755 1472.98 446.48ZM917.325 574.514C838.86 574.658 763.666 605.923 708.285 661.432C652.904 716.94 621.873 792.145 622.017 870.502C622.162 948.858 653.47 1023.95 709.055 1079.25C764.64 1134.56 839.949 1165.55 918.413 1165.4C957.265 1165.33 995.722 1157.62 1031.59 1142.71C1067.46 1127.79 1100.03 1105.97 1127.45 1078.48C1154.87 1051 1176.61 1018.39 1191.41 982.518C1206.21 946.645 1213.79 908.213 1213.72 869.415C1213.65 830.616 1205.93 792.212 1190.99 756.394C1176.06 720.577 1154.21 688.047 1126.68 660.663C1099.16 633.279 1066.51 611.577 1030.58 596.795C994.662 582.014 956.177 574.442 917.325 574.514V574.514Z"
            fill="url(#paint6_linear_3:40)"
            fillOpacity="0.1"
          />
          <path
            d="M1973.1 445.773V573.179H1523.58C1523.58 533.289 1522.61 494.487 1524.42 455.927C1524.42 448.312 1534.95 439.729 1542.44 434.29C1602.91 390.29 1665.56 347.741 1725.9 302.895C1751.11 284.567 1774.12 263.394 1794.47 239.797C1804.4 229.519 1810.4 216.088 1811.44 201.843C1812.48 187.597 1808.49 173.438 1800.16 161.831C1791.53 150.448 1779.26 142.374 1765.39 138.963C1751.51 135.552 1736.89 137.011 1723.97 143.095C1691.44 159.05 1663.5 183.226 1629.03 206.314L1529.99 124.479C1598.8 5.53523 1778.51 -37.3765 1892.19 36.3592C1913.05 50.4214 1930.71 68.7247 1944.01 90.0732C1957.31 111.422 1965.96 135.335 1969.38 160.251C1972.8 185.166 1970.93 210.524 1963.88 234.667C1956.83 258.809 1944.76 281.193 1928.47 300.357C1900.31 330.224 1869.32 357.306 1835.95 381.224C1809.47 402.136 1780.69 420.268 1753.84 445.411L1973.1 445.773Z"
            fill="white"
            fillOpacity="0.1"
          />
        </clipPath>
        <g id="radar">
          <g opacity="0.8">
            <circle
              cx="783"
              cy="820"
              r="718.2"
              stroke="#076DD3"
              strokeWidth="0.5"
              fill="url(#bgovrlylgn-bg-rad-grad)"
              opacity="0.48"
            />
            <circle
              cx="783"
              cy="820"
              r="718.2"
              stroke="#076DD3"
              strokeWidth="0.5"
            />
            <circle
              cx="782.999"
              cy="820"
              r="119.7"
              stroke="#076DD3"
              strokeWidth="0.5"
            />
            <circle
              cx="782.999"
              cy="820"
              r="239.4"
              stroke="#076DD3"
              strokeWidth="0.5"
            />
            <circle
              cx="782.999"
              cy="820"
              r="359.1"
              stroke="#076DD3"
              strokeWidth="0.5"
            />
            <circle
              cx="782.999"
              cy="820"
              r="478.8"
              stroke="#076DD3"
              strokeWidth="0.5"
            />
            <circle
              cx="782.999"
              cy="820"
              r="598.5"
              stroke="#076DD3"
              strokeWidth="0.5"
            />
          </g>
          <path
            d="M 1261.8 820 C 1266.79 924.738 1088.9 1021.16 1035.7 1072.7 C 982.5 1124.24 871.113 1202.37 782.999 1179.1 C 694.886 1155.83 673.275 1049.43 613.425 989.575 C 553.575 929.725 478.76 911.437 423.9 820 C 369.039 728.562 390.65 590.576 443.85 480.85 C 497.05 371.125 666.624 198.225 782.999 221.5 C 899.374 244.775 877.762 568.962 952.574 650.425 C 1027.39 731.888 1256.81 715.263 1261.8 820 Z"
            stroke="#3088E0"
            strokeWidth="2"
          />
        </g>
        <filter
          id="filter0_f_3:40"
          x="0.800049"
          y="37.8"
          width="1564.4"
          height="1564.4"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="32"
            result="effect1_foregroundBlur_3:40"
          />
        </filter>
        <filter id="bgovrlylgn-bg-blur" colorInterpolationFilters="sRGB">
          <feGaussianBlur in="SourceGraphic" stdDeviation="6" />
        </filter>
        <radialGradient id="bgovrlylgn-bg-rad-grad">
          <stop offset="50%" stopColor="#0A44AF" />
          <stop offset="100%" stopColor="#061741" stopOpacity="0" />
        </radialGradient>
        <linearGradient
          id="paint6_linear_3:40"
          x1="1152.96"
          y1="500.905"
          x2="543.727"
          y2="1099.81"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default AuthLayoutBackground;
